import type { SVGProps } from 'react'
const SvgSyArrowDownCircle = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path
			fillRule="evenodd"
			d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2m0 1.5c4.7 0 8.5 3.8 8.5 8.5s-3.8 8.5-8.5 8.5-8.5-3.8-8.5-8.5S7.3 3.5 12 3.5"
			opacity={0.4}
		/>
		<path d="M8.6 10c-.2 0-.4 0-.5.2-.3.3-.3.8 0 1.1l3.5 3.5c.3.3.8.3 1.1 0l3.5-3.5c.3-.3.3-.8 0-1.1s-.8-.3-1.1 0l-2.9 3-2.9-3c-.1-.1-.3-.2-.5-.2z" />
	</svg>
)
export default SvgSyArrowDownCircle
